import { createSelector } from "@reduxjs/toolkit";
import type { IProduct, IProductOption } from "../types";
import type { RootState } from "../../store";
import { getMoneyString } from "../../util/helpers";

const selector = (state: RootState) => {
  const categories = state.category.list;
  return state.productSearch.list.reduce(
    (res: IProductOption[], curr: IProduct) => {
      const { category = "" } = curr;
      const categoryExist = categories.some(o => o.title === category);
      if (!categoryExist) return res;
      return [
        ...res,
        {
          label: [curr.name, curr.category].filter(Boolean).join(" — "),
          value: curr._id,
          details: `${getMoneyString(curr.price)}`,
        },
      ];

    },
    []
  );
};

export const productOptions = createSelector(selector, (list) => list);
